import React from 'react';
import classes from "../styles/Login.module.css";
import Input from "./Input/Input";
import Button from "./Button/Button";
import {BUTTON_TYPES} from "./Button/buttonTypes";
import Spinner from "./Spinner/Spinner";


const SetPasswordComponent = ({form, loading, onChange, onSubmit}) => {

  return (
      <div>
        <div className={classes.marginBottom26}>
          <Input
              name='password'
              label='Password'
              id='password'
              placeholder='Enter new password'
              type='password'
              value={form.password.value}
              onChange={onChange}
              error={form.password.touched && !form.password.valid}
          />
        </div>
        <div>
          <Input
              name='re_password'
              label='Repeat Password'
              id='re_password'
              placeholder='Repeat your password'
              type='password'
              value={form.re_password.value}
              onChange={onChange}
              error={form.re_password.touched && !form.re_password.valid}
          />
        </div>
        <div className={classes.Button}>
          <Button
            type={BUTTON_TYPES.PRIMARY}
            onClick={onSubmit}
            disabled={loading}
          >
            {loading ? <Spinner /> : 'Set password'}
          </Button>
        </div>
      </div>
  );
};

export default SetPasswordComponent;